import React, {useRef} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import {Check, Close} from "@material-ui/icons";
import Dialog from "@material-ui/core/Dialog";
import PropTypes from "prop-types";
import Button from "@material-ui/core/Button";
import clsx from "clsx";

const useStyles = toolBarBackgroundColor => makeStyles(theme => ({
    root: {},
    appBar: {
        position: 'relative',
        marginBottom: 0
    },
    toolBarBackgroundColor: {
        backgroundColor: toolBarBackgroundColor ? toolBarBackgroundColor : theme.palette.primary.main
    },
    iframe: {
        width: "100%",
        height: "100%",
        border: 0
    },
    leftIcon: {
        marginRight: theme.spacing()
    },
    iconSmall: {
        fontSize: 20
    },
    flex: {
        flexGrow: 1
    },
    secondaryActionButton: {
        fontSize: theme.typography.htmlFontSize
    },
    bottomAppBar: {
        top: 'auto',
        bottom: 0,
    },
    bottomToolBar: {
        display: 'flex',
        justifyContent: 'center'
    }
}));

export default function IframeModal(props) {
    const {
        open = false,
        closable = true,
        onClose,
        onLoad = null,
        title,
        url,
        toolBarBackgroundColor,
        secondaryAction = false,
        tertiaryAction = false,
        buttonBarContent
    } = props;
    const classes = useStyles(toolBarBackgroundColor)();
    const iframeRef = useRef();

    const onClickSecondaryAction = event => {
        event.preventDefault();

        !!secondaryAction && !!secondaryAction.onClick && secondaryAction.onClick(event, iframeRef.current);
    };

    const onClickTertiaryAction = event => {
        event.preventDefault();

        !!tertiaryAction && !!tertiaryAction.onClick && tertiaryAction.onClick(event, iframeRef.current);
    };

    return (
        <Dialog
            fullScreen
            open={open}
            onClose={onClose}>
            <AppBar className={clsx(classes.appBar, classes.toolBarBackgroundColor)}>
                <Toolbar variant="dense">
                    {closable && (
                        <>
                            <IconButton
                                color="inherit"
                                onClick={onClose}
                                aria-label="Fechar">
                                <Close />
                            </IconButton>
                            <Typography
                                variant="h6"
                                color="inherit"
                                className={classes.flex}>
                                Fechar
                            </Typography>
                        </>
                    )}
                    {title && (
                        <Typography
                            variant="h6"
                            color="inherit"
                            className={classes.flex}>
                            {title}
                        </Typography>
                    )}
                    {secondaryAction && (
                        <Button
                            color="inherit"
                            startIcon={secondaryAction.icon}
                            onClick={onClickSecondaryAction}>
                            {secondaryAction.text}
                        </Button>
                    )}
                    {tertiaryAction && (
                        <Button
                            color="inherit"
                            startIcon={tertiaryAction.icon}
                            onClick={onClickTertiaryAction}>
                            {tertiaryAction.text}
                        </Button>
                    )}
                </Toolbar>
            </AppBar>
            <iframe
                ref={iframeRef}
                src={url}
                onLoad={onLoad}
                className={classes.iframe}>
            </iframe>
            {!!buttonBarContent && (
                <AppBar position="fixed" color="secondary" className={classes.bottomAppBar}>
                    <Toolbar className={classes.bottomToolBar}>
                        {buttonBarContent}
                    </Toolbar>
                </AppBar>
            )}
        </Dialog>
    );
}

IframeModal.propTypes = {
    open: PropTypes.bool.isRequired,
    closable: PropTypes.bool,
    onClose: PropTypes.func,
    onLoad: PropTypes.func,
    title: PropTypes.string,
    url: PropTypes.string,
    secondaryAction: PropTypes.object,
    tertiaryAction: PropTypes.object,
    buttonBarContent: PropTypes.element
};